import { useTranslation } from "react-i18next";
import { getButtonsNoYes } from "context/helpers/helperModalContext";
import { useModal } from "context/ModalContext";
import { useRef } from "react";
import { DateTime as DT } from "luxon";
import AppDatePicker from "components/dateTime/AppDatePicker";

const useChangeDate = () => {

    const { t } =useTranslation();
    const { showDlg } = useModal();
    const refInputDate = useRef();
    const refForm = useRef();
    const paramsDelDlg = {
        buttons : [...getButtonsNoYes(t)], 
        type    : 'confirm',
    }  

    const changeDate = (defValue, cbFunct) => {


        const handleSubmit = async (e) =>{
            e.preventDefault();
            const iso = refInputDate.current;
            if (!iso) return;
            const dt = DT.fromISO(iso, { zone: 'local' }).toMillis();
            if (!dt) return;
            cbFunct(dt);            
            showDlg(false);
        }

        const defDate =   DT.fromMillis(defValue, { zone: 'local' }).toISODate();
        refInputDate.current = defDate || '';


        const p = {
            ...paramsDelDlg,
            text: (<>
                <div style={{marginTop:-25}}>
                    <form onSubmit={handleSubmit}
                        ref={refForm}>
                    <label className="label-control">{t('changeDate')}</label>
                    <AppDatePicker
                        defaultValue={defDate || ''}
                        onChange={(iso) => { refInputDate.current = iso; }}
                    />
                    <button type="submit" className="d-none"></button>
                    </form>
                </div>
            </>)
        }
        p.buttons[1].handleClick = async () => {  
            if (!refInputDate.current) return;
            if (refForm.current.reportValidity()) {
                refForm.current.requestSubmit();
            }
        }
        showDlg(p);
        
    }

    return {
        changeDate
    }
}

export default useChangeDate;